// extracted by mini-css-extract-plugin
export default {"label":"WordUpvoteButton_label__UBH9o","num":"WordUpvoteButton_num__8GZs2"};